import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { io } from 'socket.io-client'
import { REST_API_IO } from 'src/constants/DefaultValues'
import { PATH_DASHBOARD } from 'src/routes/paths'

export const HAWKOWL_OPEN_TICKET_EVENT = 'hawkowl-open-ticket'

function getLoggedInUserId() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    return Number(user.user_id) || null
  } catch {
    return null
  }
}

function openTicketOnSite(taskId, location, navigate) {
  const id = Number(taskId)
  if (!Number.isFinite(id)) return

  const onTicketsPage =
    location.pathname.includes('/dashboard/ticket') &&
    !location.pathname.includes('/ticket/add-tickets')

  if (onTicketsPage) {
    window.dispatchEvent(
      new CustomEvent(HAWKOWL_OPEN_TICKET_EVENT, { detail: { taskId: id } })
    )
    return
  }

  navigate(`${PATH_DASHBOARD.tickets.root}?openTicket=${id}`)
}

export default function useHawkOwlTicketAutoOpen() {
  const navigate = useNavigate()
  const location = useLocation()
  const locationRef = useRef(location)

  locationRef.current = location

  useEffect(() => {
    const socket = io(REST_API_IO, {
      path: '/backend/socket.io',
      transports: ['websocket', 'polling'],
    })

    const handleTimelogUpdate = (data) => {
      if (data?.action !== 'add' || data?.source !== 'hawkowl') return

      const userId = getLoggedInUserId()
      if (!userId || Number(data.teamId) !== userId) return

      openTicketOnSite(data.taskId, locationRef.current, navigate)
    }

    socket.on('ticket-timelog-updated', handleTimelogUpdate)

    return () => {
      socket.off('ticket-timelog-updated', handleTimelogUpdate)
      socket.disconnect()
    }
  }, [navigate])
}
